import clsx from "clsx";
import { motion } from "framer-motion";

interface FgToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label?: string;
  disabled?: boolean;
}

/**
 * Dark-theme switch — track is yellow when on, off-grey when off.
 * Mirrors the iOS-style toggle with a sliding thumb.
 */
export function FgToggle({ checked, onChange, label, disabled }: FgToggleProps) {
  return (
    <label className="inline-flex cursor-pointer items-center gap-3">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
        className={clsx(
          "relative h-6 w-11 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#FFD60A] focus:ring-offset-2 focus:ring-offset-[#0A0A0A]",
          checked ? "bg-[#FFD60A]" : "bg-[#3A3A3C]",
          disabled && "opacity-50 cursor-not-allowed",
        )}
      >
        <motion.span
          layout
          transition={{ type: "spring", stiffness: 700, damping: 30 }}
          className="absolute top-0.5 left-0.5 h-5 w-5 rounded-full bg-white shadow"
          style={{ x: checked ? 20 : 0 }}
        />
      </button>
      {label && (
        <span className="text-sm font-medium text-[#FAFAFA]">{label}</span>
      )}
    </label>
  );
}
